export interface Alerter {
  greenOperator: AlerterOperator;
  redOperator: AlerterOperator;
  neutralValue: number;
}

export enum AlerterOperators {
  GREATER_THAN = '+',
  LESS_THAN = '-',
}

export type AlerterOperator = `${AlerterOperators}`;

export enum AlerterStyles {
  GREEN = 'alerter-green',
  RED = 'alerter-red',
}
